import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpEventType } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { Sessions } from 'src/app/libraries/sessions';
import { IReturn } from 'src/app/libraries/ireturn';
import { APP_BASE_HREF } from '@angular/common';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CuentasBancariasService {

  constructor(private http: HttpClient,  @Inject(APP_BASE_HREF) private baseUrl: string) { }

  dataSource(varArgs : any = null): Observable<IReturn> {
    return this.http.post<IReturn>(this.baseUrl + "api/Cuentas/Bancarias/DataSource", varArgs, Sessions.header());
  }

  create(): Observable<IReturn> {
    return this.http.post<IReturn>(this.baseUrl + "api/Cuentas/Bancarias/Create", null, Sessions.header());
  }

  store(objCuentaBancaria : any): Observable<IReturn> {
    return this.http.post<IReturn>(this.baseUrl + "api/Cuentas/Bancarias/Store", objCuentaBancaria, Sessions.header());
  }

  update(objCuentaBancaria : any): Observable<IReturn> {
    return this.http.post<IReturn>(this.baseUrl + "api/Cuentas/Bancarias/Update", objCuentaBancaria, Sessions.header());
  }

  delete(objCuentaBancaria : any): Observable<IReturn> {
    return this.http.post<IReturn>(this.baseUrl + "api/Cuentas/Bancarias/Delete", objCuentaBancaria, Sessions.header());
  }

}